import React, { useState, useEffect } from 'react';
import { AiOutlineClose } from 'react-icons/ai'

function CloseModal() {

    return(
        <>
            <div className="close-modal">
                <AiOutlineClose />
                <div>Close</div>
            </div>
        </>
    )
}

export default CloseModal